export default __webpack_public_path__ + "static/img9-4a0d06be331b89de8771e54f0602bb4c.png";